<template>
  <div class="section section_blue">
    <div class="max-width">
      <div class="benefits">
        <div class="section__head">
          <h2 class="section__title">The Competitive Edge <br>Is Already Built In</h2>
          <div class="section__text">No add-ons, no guesswork. Just powerful features that help you launch faster and convert better.</div>
        </div>
        <div class="benefits__grid">
          <div
              class="benefits__item fadeIn"
              v-for="(benefit, index) in benefits"
              :key="index"
          >
            <div class="benefits__icon">
              <component :is="benefit.icon" />
            </div>
            <div class="benefits__about">
              <h3 class="benefits__title">{{ benefit.title }}</h3>
              <div class="benefits__text">{{ benefit.text }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import IconBenefitsMoney from '@/components/icons/IconBenefitsMoney.vue'
import IconBenefitsCart from '@/components/icons/IconBenefitsCart.vue'
import IconBenefitsOptions from '@/components/icons/IconBenefitsOptions.vue'
import IconBenefitsSupport from '@/components/icons/IconBenefitsSupport.vue'

const benefits = [
  {
    title: "Sales Optimization Features",
    text: "Sales-focused features and tools, built into every theme—expertly designed to help you sell more, faster, and with less effort.",
    icon: IconBenefitsMoney,
  },
  {
    title: "Conversion-Driven Design",
    text: "Purposeful design that combines converting layouts with intuitive navigation to drive customers confidently toward purchase.",
    icon: IconBenefitsCart,
  },
  {
    title: "Customization Options",
    text: "Built-in customization options make it simple to personalize your store’s design and functionality to match your brand and meet customer expectations.",
    icon: IconBenefitsOptions,
  },
  {
    title: "One-of-a-Kind Support You Can Rely On",
    text: "Get expert support on business days, even during your trial. We typically respond within 15 minutes during support hours.",
    icon: IconBenefitsSupport,
  },
]
</script>

<style lang="scss">
.benefits {
  &__grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;

    @include xs {
      grid-template-columns: 1fr;
    }
  }

  &__item {
    border-radius: 12px;
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 2rem;
    min-height: 380px;
    gap: 3rem;

    @include xs {
      min-height: initial;
      padding: 1.5rem;
    }
  }

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: linear-gradient(110deg, #bbff4c 0%, #378cff 75%, #cffff2 87.98%);
    width: 66px;
    height: 66px;

    @include xs {
      width: 50px;
      height: 50px;

      svg {
        width: 32px;
        height: 32px;
      }
    }
  }

  &__title {
    font-size: 1.5rem;
    font-weight: 600;
    font-family: var(--font-family);
    margin: 0 0 0.5rem;

    @include xs {
      font-size: 1.25rem;
    }
  }

  &__text {
    max-width: 440px;
    color: var(--color-gray);
  }
}
</style>
